import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from 'react-bootstrap';
import ProfilePhoto from '../../../../styles/images/profile-photo.png';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import { handleChangeInputsEditProfilePage } from "../../../../redux/actions/pages/user/edit_profile";
import { handleChangeProfileData } from "../../../../redux/actions/pages/user/user";
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { BASE_SITE, USERS_EDIT_PROFILE } from '../../../../apis'; 
import axios from "axios";
import * as qs from "querystring";
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';

const EditProfile = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.user);
    const { fname, lname, gender, isLoading } = useSelector(state => state.edit_profile);

    useEffect(() => {
        dispatch(handleChangeInputsEditProfilePage('fname', profile.fname));
        dispatch(handleChangeInputsEditProfilePage('lname', profile.lname));
        if(profile.gender !== null)
            dispatch(handleChangeInputsEditProfilePage('gender', profile.gender));
        // eslint-disable-next-line
    }, [EditProfile]);

    const handleBackBtn = () => {
        navigate(-1);
    };


    const handelChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputsEditProfilePage(name, value));
    };

    const handleBtnEditProfile = () => {
        if(! isLoading) {
            dispatch(handleChangeInputsEditProfilePage('isLoading', true));

            let isError = false;
            if(fname === null || fname.length === 0) {
                isError = true;
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام خود را وارد کنید!', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
            }
            if(lname === null || lname.length === 0) {
                isError = true;
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام خانوادگی خود را وارد کنید!', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
            }
            if(gender === null || gender === 'انتخاب کنید') {
                isError = true;
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'جنسیت خود را مشخص کنید!', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
            }
            if(!isError) {
                dispatch(handleSetBackdropLoading(true));

                axios({
                    method: 'post',
                    url: BASE_SITE + USERS_EDIT_PROFILE,
                    data: qs.stringify({
                        fname,
                        lname,
                        gender,
                    }),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': token
                    },
                }).then((response) => {
                    switch (response.data.status) {
                        case 'error':
                            dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                            break;
                        case 'ok':
                            let newProfile = {...profile, fname: fname, lname: lname, gender: gender};
                            dispatch(handleChangeProfileData(newProfile));

                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'اطلاعات کاربری شما با موفقیت ویرایش شد.', severity: 'success', vertical: 'bottom', horizontal: 'center'}));  
                            handleBackBtn();
                            break;
                        default:
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    }
                    dispatch(handleSetBackdropLoading(false));
                    dispatch(handleChangeInputsEditProfilePage('isLoading', false));
                }, () => {
                    dispatch(handleSetBackdropLoading(false));
                    dispatch(handleChangeInputsEditProfilePage('isLoading', false));
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                });
            }
            else 
                dispatch(handleChangeInputsEditProfilePage('isLoading', false));
        }
            
    };

    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    return (

        <div id="edit-profile-page" onClick={closeBottomSheet} >

            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1}><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10}><h4 className="text-center">حساب کاربری</h4></Col>
                <Col xs={1}></Col>
            </Row>

            <div className="d-flex justify-content-start short-profile mt-4 p-4">
                <img src={ProfilePhoto} width={60} className="mr-4" />
                <div className="d-flex flex-column justify-content-center">
                    <span className="phone-num">{profile.mobile}</span>
                </div>
            </div>

            <Row>
                <Col xs={12} className="mt-5">
                    <div className="input-wrapper" >
                        <label className="label-wrapper" htmlFor="first" >نام</label>
                        <input type="text" name="fname" value={fname} onChange={handelChangeInputs} className="custom-input w-100 px-3 custom-vertical-padding" />
                    </div>
                </Col>

                <Col xs={12} className="mt-3">
                    <div className="input-wrapper" >
                        <label className="label-wrapper" htmlFor="first" >نام خانوادگی</label>
                        <input type="text" name="lname" value={lname} onChange={handelChangeInputs} className="custom-input w-100 px-3 custom-vertical-padding" />
                    </div>
                </Col>

                <Col xs={12} className="mt-3">
                    <div className="input-wrapper" >
                        <label className="label-wrapper" htmlFor="first" >جنسیت</label>
                        <select name="gender" value={gender} onChange={handelChangeInputs} className="custom-input w-100 px-3 custom-vertical-padding">
                            <option>انتخاب کنید</option>
                            <option>مرد</option>
                            <option>زن</option>
                        </select>
                    </div>
                </Col>

                <Col xs={12} className="mt-4">
                    <Button onClick={handleBtnEditProfile} className="w-100 py-3 login-form-button">
                        ویرایش تغییرات
                    </Button>
                </Col>

                
            </Row>
            
        </div>

    );
}

export default EditProfile;